var keydown = 0,
	$window = $(window),
	$header = $('.js-header'),
	$body = $('.js-body'),
	$footer = $('.js-footer'),
    ww = $window.width(),
    wh = $window.height(),
    hh = $header.outerHeight(),
    scrollTop = $window.scrollTop(),
    scrollBot = scrollTop + wh,
    screenSm = 577,
    screenMd = 769;
    if ($footer.lenght) {
        var fTop = $footer.offset().top;
    }


function updateVar() {
	ww = $window.width();
    wh = $window.height();
    hh = $header.outerHeight();
    if ($footer.length) {
        fTop = $footer.offset().top;
    }
};

function updateScroll() {
	scrollTop = $window.scrollTop();
    scrollBot = scrollTop + wh;
    if ($footer.length) {
        fTop = $footer.offset().top;
    }
};

function updataAll() {
	updateVar();
    updateScroll();
};

$(function(){
    updataAll();

    $window.on('scroll', function(e){
        e.preventDefault();
    	updateScroll();
    });

    $window.resize(function(){
    	updataAll();
    });

});
